import { ChangeDetectorRef, Directive, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { App } from '@df/core/app';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { Giftcards } from '@df/module-giftcards/giftcards';

@Directive()
export abstract class GiftcardsAmountSelectorComponentDef implements OnChanges {
    amounts?: number[];

    maxAmount?: number;

    minAmount?: number;

    app = inject(App);

    @Input()
    product?: Product;

    @Input()
    noDefault?: boolean;

    @Input()
    request?: Giftcards.ISelectionContainer;

    /**
     * notifies request changes
     */
    @Output()
    update = new EventEmitter<void>();

    constructor(protected _ref: ChangeDetectorRef) {}

    ngOnChanges(changes) {
        if (changes.product) {
            if (this.product?.hasV3) {
                const data = this.product.data as IProductDataV3;
                this.minAmount = data.am_open_amount_min;
                this.maxAmount = data.am_open_amount_max;
                this.amounts = data.am_giftcard_prices;
            } else {
                this.minAmount = undefined;
                this.maxAmount = undefined;
                this.amounts = undefined;
            }

            if (this.request?.am_giftcard_amount) {
                this.selectAmount(this.request.am_giftcard_amount);
            }
            if (this.request?.am_giftcard_amount_custom) {
                this.onCustomAmountChange();
            }

            if (
                this.request &&
                !this.request.am_giftcard_amount &&
                !this.request.am_giftcard_amount_custom &&
                this.amounts?.length &&
                !this.noDefault
            ) {
                this.selectAmount(this.amounts[0]);
            }
        }
    }

    selectAmount(value: number): void {
        if (this.request) {
            if (this.isCorrectAmount(value)) {
                this.request.am_giftcard_amount = value;
            } else {
                this.request.am_giftcard_amount = undefined;
            }
            if (this.request.am_giftcard_amount_custom) {
                delete this.request.am_giftcard_amount_custom;
            }
            this.triggerUpdate();
        }
        this.detectChanges();
    }

    onCustomAmountChange(): void {
        const customAmount = this.request?.am_giftcard_amount_custom;
        if (typeof customAmount === 'number' && !this.isCorrectCustomAmount(customAmount)) {
            delete this.request!.am_giftcard_amount_custom;
        } else if (this.request?.am_giftcard_amount_custom && this.request.am_giftcard_amount) {
            delete this.request.am_giftcard_amount;
        }
        this.triggerUpdate();
    }

    protected isCorrectAmount(value: number): boolean {
        return (this.amounts || []).indexOf(value) > -1;
    }

    protected isCorrectCustomAmount(value: number): boolean {
        if (this.isMinValueError(value)) {
            return false;
        }
        if (this.isMaxValueError(value)) {
            return false;
        }
        return true;
    }

    protected isMinValueError(value: number): boolean {
        return typeof this.minAmount === 'number' && value < this.minAmount;
    }

    protected isMaxValueError(value: number): boolean {
        return typeof this.maxAmount === 'number' && value > this.maxAmount;
    }

    trackByFn(index: number) {
        return index;
    }

    protected triggerUpdate() {
        this.update.emit();
    }

    protected detectChanges(): void {
        this._ref.detectChanges();
    }
}
